module.exports = __webpack_public_path__ + "static/media/logo.cbf8c133.png";